module.exports = ".up-arrow{padding:0 !important;font-size:14px !important}.down-arrow{padding:0 !important;font-size:14px !important;margin-left:-0.5rem}"